const Months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export const monthsOptions = Months.map((month: string, index: number) => ({
  label: month,
  value: month.toLowerCase()
}));